import React from 'react';
import cx from 'classnames';

import { ConditionalView } from '../../utils/ConditionalView';
import Icon from '../Icon';
import IconButton from '../IconButton';
import Input from '../Input';
import styles from './Password.module.scss';
import usePresenter from './Password.presenter';
import { PasswordProps } from './Password.types';

const Password = (props: PasswordProps) => {
  const {
    showPassword,
    togglePassword,
    variantProps,
    hideTrailingIcon,
    otherPasswordProps,
  } = usePresenter(props);

  const visibilityOffIcon = <Icon className={cx({ [styles.hide]: !showPassword })} icon={'VisibilityOff'} size='Small' />;
  const visibilityOnIcon = <Icon className={cx({ [styles.hide]: showPassword })} icon={'VisibilityOn'} size='Small' />;

  const baseAriaLabel = otherPasswordProps['aria-label'] != null ? otherPasswordProps['aria-label'] : 'Password';
  const toggleAriaLabel = `${baseAriaLabel}--toggle-password-visibility`;
  const toggleAriaLabelledBy = otherPasswordProps['aria-labelledby'] != null
    ? `${otherPasswordProps['aria-labelledby']}--toggle-password-visibility`
    : undefined;

  return (
    <Input
      {...otherPasswordProps}
      autoComplete={otherPasswordProps.autoComplete ?? "current-password"}
      className={cx(styles.password, props.className)}
      inputType={showPassword ? 'Text' : 'Password'}
      trailingIcon={(
        <ConditionalView condition={!hideTrailingIcon}>
          <IconButton
            className={styles.toggle}
            size='Small'
            type='Ghost'
            aria-label={toggleAriaLabel}
            aria-labelledby={toggleAriaLabelledBy}
            icon={(
              <>
                {visibilityOffIcon}
                {visibilityOnIcon}
              </>
            )}
            onClick={togglePassword}
            disabled={props.disabled}
          />
        </ConditionalView>
      )}
      {...variantProps}
    />
  );

};

export default Password;